// extracted by mini-css-extract-plugin
module.exports = {"resources-menu-container":"Resources_resources-menu-container__qqV4E","resources-menu-items":"Resources_resources-menu-items__KNoEt"};